import { useState } from 'react';
import { uploadFile } from '../domain/useCases/Upload/uploadFile.js';
import { uploadMultipleFiles as uploadMultipleUseCase } from '../domain/useCases/Upload/uploadMultipleFiles.js';

export const useUpload = () => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Upload a single file
   * @param {File} file - The file to upload
   * @returns {Promise<string>} - The uploaded file URL
   */
  const uploadSingleFile = async (file) => {
    if (!file) {
      const err = new Error('No file provided');
      setError(err.message);
      throw err;
    }

    setUploading(true);
    setError(null);

    try {
      console.log('useUpload: Uploading single file:', file.name);
      const url = await uploadFile(file);
      console.log('useUpload: uploadFile returned:', url);
      console.log('useUpload: URL type:', typeof url);
      console.log('useUpload: URL is valid:', url && typeof url === 'string' && url.length > 0);
      if (!url || typeof url !== 'string') {
        throw new Error('Invalid upload response - no URL returned');
      }
      console.log('useUpload: Upload successful, URL:', url);
      return url;
    } catch (err) {
      console.error('useUpload: Upload error:', err);
      setError(err.message);
      throw err;
    } finally {
      setUploading(false);
    }
  };

  /**
   * Upload multiple files
   * @param {FileList|File[]} files - The files to upload
   * @returns {Promise<string[]>} - Array of uploaded file URLs
   */
  const uploadMultipleFiles = async (files) => {
    if (!files || files.length === 0) {
      const err = new Error('No files provided');
      setError(err.message);
      throw err;
    }

    setUploading(true);
    setError(null);

    try {
      console.log('useUpload: Uploading multiple files:', files.length);
      const fileArray = Array.from(files);
      const urls = await uploadMultipleUseCase(fileArray);
      console.log('useUpload: Upload successful, URLs:', urls);
      return urls;
    } catch (err) {
      console.error('useUpload: Upload error:', err);
      setError(err.message);
      throw err;
    } finally {
      setUploading(false);
    }
  };

  return {
    uploadSingleFile,
    uploadMultipleFiles,
    uploading,
    error,
    setError,
  };
};

export default useUpload;
